export default {
    courseSelectionOption: {
        color:['#4CB7FE','#FFC271','#61E6CA'],
        tooltip: {
            trigger: 'item',
            formatter: function (param) {
                return '<div>' + param.name + '</div><div>人数：'+param.value+'('+param.percent+'%)</div>'
            }
        },
        legend: {
            orient:'vertical',
            left:0,
            top:'40%',
            data: ['已选课','未选课','部分选课'],
            itemWidth:12,
            itemHeight:10
        },
        series: [
            {
                name:'选课进度',
                type:'pie',
                center:['50%','60%'],
                radius: ['0%', '60%'],
                avoidLabelOverlap: false,
                label: {
                    normal: {
                        show: false,
                        position: 'center'
                    },
                    emphasis: {
                        show: false
                    }
                },
                labelLine: {
                    normal: {
                        show: true
                    }
                },
                data:[]
            }
        ]
    },
}


// WEBPACK FOOTER //
// ./src/components/homepage/widget/electiveCourseOption.js